import React, { useState } from 'react';
import { Pizza, Sandwich, UtensilsCrossed, Salad, ChefHat, Wine, IceCream, Gift, Flame } from 'lucide-react';
import { MenuModal } from './MenuModal';

export const MenuSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('pizzas');

  const categories = [
    { id: 'pizzas', title: 'Les Pizzas', icon: Pizza },
    { id: 'sandwiches', title: 'Les Sandwichs', icon: Sandwich },
    { id: 'tacos', title: 'French Tacos', icon: UtensilsCrossed },
    { id: 'burgers', title: 'Les Burgers', icon: ChefHat },
    { id: 'assiettes', title: 'Les Assiettes', icon: UtensilsCrossed },
    { id: 'braises', title: 'Les Rôtis', icon: Flame },
    { id: 'salades', title: 'Les Salades', icon: Salad },
    { id: 'paninis', title: 'Les Paninis', icon: Sandwich },
    { id: 'texmex', title: 'Tex Mex', icon: ChefHat },
    { id: 'boissons', title: 'Les Boissons', icon: Wine },
    { id: 'desserts', title: 'Desserts', icon: IceCream },
    { id: 'glaces', title: 'Glaces', icon: IceCream },
    { id: 'menus', title: 'Menus', icon: Gift }
  ];

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
    setIsModalOpen(true);
  };

  return (
    <section id="menu" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
          >
            Notre Menu
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Cliquez sur une catégorie pour découvrir nos spécialités
          </p>
        </div>

        {/* Menu Category Cards Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {categories.map((category) => {
            const IconComponent = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => handleCategoryClick(category.id)}
                className="group relative bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A] border-2 border-[#D4A85F]/30 rounded-xl p-6 hover:border-[#D4A85F] transition-all duration-300 hover:shadow-xl hover:shadow-[#D4A85F]/20 cursor-pointer"
              >
                <div className="flex flex-col items-center text-center space-y-3">
                  <div className="bg-[#D4A85F]/10 p-4 rounded-full group-hover:bg-[#D4A85F]/20 transition-all duration-300">
                    <IconComponent className="text-[#D4A85F] w-8 h-8" />
                  </div>
                  <h3 className="text-white font-semibold text-lg group-hover:text-[#ECEC75] transition-colors duration-200">
                    {category.title}
                  </h3>
                </div>
              </button>
            );
          })}
        </div>

        {/* Menu Modal */}
        <MenuModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          initialCategory={selectedCategory}
        />
      </div>
    </section>
  );
};
